export default "__VITE_ASSET__BtUcOx8e__"